import React from "react"
import ProsObs from "../prodect/ProsObs"

export default function ProdectViewer(props){

    //For testing
    const obs = {
        "txt3": "Hessu;Mikki;Roope",
        "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
        "updated_ms": 1706309130927,
        "expires": 0,
        "created_by": "contact@thesamp.com",
        "txt2": "?#?",
        "text": "Kuvatesti",
        "obj_state": "ACT",
        "obs_hist": "0;1702035997806;contact@thesamp.com;;4;1704977205211;contact@thesamp.com;;0;1705939781574;contact@thesamp.com;;4;1705940480673;contact@thesamp.com;;3;1705940487841;contact@thesamp.com;;6;1705940518819;contact@thesamp.com",
        "updated_by": "contact@thesamp.com",
        "created_ms": 1702035997806,
        "tag7": "1",
        "sort_order": 1702035997812,
        "tag2": "6",
        "tag3": "8",
        "obj_type": "itm_obs",
        "age": 199,
        "ui_Picts": [
            {
                "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702121521272_1",
                "updated_ms": 1705766008632,
                "pict_loc_w": "0.3810848400556328",
                "created_by": "contact@thesamp.com",
                "has_picture_loc": "Y",
                "pict_overlay": "LocOverlay/88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702121521272_1_1705766009604.png",
                "text": "?#?",
                "obj_state": "ACT",
                "pict_loc_w_prev": "0.3810848400556328",
                "pict_loc_h": "0.5066162570888468",
                "updated_by": "contact@thesamp.com",
                "created_ms": 1702121521631,
                "parent_obs": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
                "pict_loc_h_prev": "0.5066162570888468",
                "sort_order": 1702121521272,
                "file_name": "W20145_1702121520059_57c36831-f155-4c7b-9da9-34c65159e59e.png",
                "obj_type": "itm_pict_loc",
                "age": 183
            },
            {
                "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702121108531_10",
                "updated_ms": 1702121106915,
                "created_by": "contact@thesamp.com",
                "text": "?#?",
                "obj_state": "ACT",
                "updated_by": "contact@thesamp.com",
                "created_ms": 1702121108829,
                "parent_obs": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
                "sort_order": 1703764136919,
                "file_name": "W20145_1702121107073_fa7de246-5d2c-462b-9155-2b0087b877f7.jpg",
                "obj_type": "itm_pict",
                "age": 146
            },
            {
                "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20156_1707213998905_1",
                "updated_ms": 1707213997209,
                "created_by": "contact@thesamp.com",
                "text": "?#?",
                "obj_state": "ACT",
                "updated_by": "contact@thesamp.com",
                "created_ms": 1707213999116,
                "parent_obs": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
                "sort_order": 1707213998905,
                "file_name": "W20156_1707213998538_877f18cb-e9e6-488c-80a7-619de412c880.png",
                "obj_type": "itm_pict",
                "age": 202
            }
        ],
        "ui_Videos": [],
        "obsObjList": [
            {
                "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702121521272_1",
                "updated_ms": 1705766008632,
                "pict_loc_w": "0.3810848400556328",
                "created_by": "contact@thesamp.com",
                "has_picture_loc": "Y",
                "pict_overlay": "LocOverlay/88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702121521272_1_1705766009604.png",
                "text": "?#?",
                "obj_state": "ACT",
                "pict_loc_w_prev": "0.3810848400556328",
                "pict_loc_h": "0.5066162570888468",
                "updated_by": "contact@thesamp.com",
                "created_ms": 1702121521631,
                "parent_obs": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
                "pict_loc_h_prev": "0.5066162570888468",
                "sort_order": 1702121521272,
                "file_name": "W20145_1702121520059_57c36831-f155-4c7b-9da9-34c65159e59e.png",
                "obj_type": "itm_pict_loc",
                "age": 183
            },
            {
                "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702121108531_10",
                "updated_ms": 1702121106915,
                "created_by": "contact@thesamp.com",
                "text": "?#?",
                "obj_state": "ACT",
                "updated_by": "contact@thesamp.com",
                "created_ms": 1702121108829,
                "parent_obs": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
                "sort_order": 1703764136919,
                "file_name": "W20145_1702121107073_fa7de246-5d2c-462b-9155-2b0087b877f7.jpg",
                "obj_type": "itm_pict",
                "age": 146
            },
            {
                "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20156_1705406752567_133",
                "updated_ms": 1705406750698,
                "created_by": "contact@thesamp.com",
                "text": "Shot in September 1972, then sat on the shelf for 4 years, looking for a distributor. In the end, it went straight to television.",
                "obj_state": "ACT",
                "updated_by": "contact@thesamp.com",
                "created_ms": 1705406752694,
                "parent_obs": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
                "sort_order": 1705406752567,
                "obj_type": "itm",
                "age": 139
            },
            {
                "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20156_1705406857831_136",
                "updated_ms": 1705406855962,
                "created_by": "el.sampo.digital@gmail.com",
                "text": "Chase Cordell only played the Moon Beast monster for one scene: the hospital transformation sequence. For other scenes the monster was portrayed by a taller actor: makeup artist Joe Blasco.",
                "obj_state": "ACT",
                "updated_by": "el.sampo.digital@gmail.com",
                "created_ms": 1705406857958,
                "parent_obs": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
                "sort_order": 1705406759958,
                "obj_type": "itm",
                "age": 142
            },
            {
                "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20156_1705406767350_134",
                "updated_ms": 1705406765482,
                "created_by": "contact@thesamp.com",
                "text": "The original cut of Track of the Moon Beast contained more graphic horror makeup. The camp massacre scene in particular had more gruesome shots of victims. However, this footage was heavily cut down as the film went to television in 1976. The censored television cut of the film is the only one available at this time.",
                "obj_state": "ACT",
                "updated_by": "contact@thesamp.com",
                "created_ms": 1705406767477,
                "parent_obs": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
                "sort_order": 1705406767350,
                "obj_type": "itm",
                "age": 140
            },
            {
                "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20156_1705406822165_135",
                "updated_ms": 1705406820309,
                "created_by": "el.sampo.digital@gmail.com",
                "text": "Frank Larrabee and his band performed their song \"California Lady\" in the film after they were coerced by the filmmakers. The film crew and the band were both staying in the local Ramada Inn in Albuquerque where the performance footage was shot.",
                "obj_state": "ACT",
                "updated_by": "el.sampo.digital@gmail.com",
                "created_ms": 1705406822305,
                "parent_obs": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
                "sort_order": 1705406822165,
                "obj_type": "itm",
                "age": 141
            },
            {
                "obj_id": "88269554-213d-42f8-85a4-2dc5ff56b743_W20156_1707213998905_1",
                "updated_ms": 1707213997209,
                "created_by": "contact@thesamp.com",
                "text": "?#?",
                "obj_state": "ACT",
                "updated_by": "contact@thesamp.com",
                "created_ms": 1707213999116,
                "parent_obs": "88269554-213d-42f8-85a4-2dc5ff56b743_W20145_1702035997567_1",
                "sort_order": 1707213998905,
                "file_name": "W20156_1707213998538_877f18cb-e9e6-488c-80a7-619de412c880.png",
                "obj_type": "itm_pict",
                "age": 202
            }
        ],
        "ui_text": "Kuvatesti",
        "ui_lastUpdatedBy": "contact@thesamp.com",
        "ui_lastUpdatedMs": 1707213997209,
        "ui_isOpen": true
    }
    //<ProsObs obs={obs} report={this.props.report} isOpen={isObsOpen} isSidePanel={this.props.isObsSidePanel} />
    return <ProsObs obs={obs} isOpen={true} isSidePanel={false}/>
}

